module.exports = __webpack_public_path__ + "img/qjxd_banner_tc.61d5ebdb.png";